import { AuthenticationPagesTheme } from "@acin.reactjs/acin-ui/login";
import theme, {
  ComponentCSSStyle,
  getMaxWidthMediaQuery,
} from "@acin.reactjs/acin-ui/theme";

const LoginTheme = (): ComponentCSSStyle<AuthenticationPagesTheme> => ({
  contentSkeleton: {
    root: {
      padding: "130px 75px 90px",
    },
    logoSection: {
      root: {
        [getMaxWidthMediaQuery(theme.breakpoints.md)]: {
          paddingTop: "16px",
        },
      },
    },
  },
  carousel: {
    banner: {
      "& > img, & > video": {
        height: "auto",
      },
    },
    container: {
      "& .swiper-slide": {
        transform: "translateX(-2px)",
      },
    },
  },

  title: {
    color: theme.palette.common.black,
  },
  twoFactorAuthenticationPage: {
    resendCode: {
      color: theme.palette.common.black,
    },
    verificationCodeInput: {
      container: {
        width: "52px",
        height: "64px !important",
      },
      input: {
        fontSize: "24px",
        lineHeight: "32px",
        letterSpacing: "0px",
        color: theme.palette.common.black,
        margin: "0px",
        padding: "0px",
      },
    },
    inputsContainer: {
      flexWrap: "nowrap",
    },
  },
});

export default LoginTheme;
